<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <p class="subtitle-1 font-weight-bold px-10 pt-8 mb-0">
        Generate month to date statement
      </p>
      <v-container class="pa-0 px-4">
        <v-row>
          <v-col cols="12" sm="8" md="8">
            <v-menu
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="parsedDate"
                  label="Select month"
                  v-bind="attrs"
                  readonly
                  outlined
                  dense
                  hide-details
                >
                  <template v-slot:prepend-inner>
                    <v-icon small class="mt-1">mdi-calendar-month</v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                type="month"
                no-title
                scrollable
                readonly
                disabled
                @input="dateMenu = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-select
              v-model="sortBy"
              outlined
              flat
              hide-details
              label="Sort"
              :items="sortItems"
              dense
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <a @click="downloadMonthlyStatement">
              <v-card
                id="bed-space"
                outlined
                hover
                class="text-center card-option"
              >
                <v-icon size="50" class="mt-4">mdi-download</v-icon>
                <v-card-title class="justify-center">Download PDF</v-card-title>
                <v-card-subtitle>
                  Downloads a month-to-date report for your viewing
                </v-card-subtitle>
              </v-card>
            </a>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <a @click="sendMonthlyStatement">
              <v-card
                id="apartment"
                outlined
                hover
                class="text-center card-option"
              >
                <v-icon size="50" class="mt-4">mdi-email-send</v-icon>
                <v-card-title class="justify-center"
                  >Email to tenant</v-card-title
                >
                <v-card-subtitle>
                  Sends the report to the tenant's email address
                </v-card-subtitle>
              </v-card>
            </a>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { dayjs } from '../../util/date'

export default {
  data() {
    return {
      bedDetails: null,
      dialog: false,
      options: {
        color: 'primary',
        width: 700,
        zIndex: 200
      },
      date: dayjs().format('YYYY-MM'),
      dateMenu: false,
      sortItems: [
        { text: 'Created', value: 'created' },
        { text: 'Due date', value: 'dueDate' }
      ],
      sortBy: 'dueDate'
    }
  },
  computed: {
    parsedDate() {
      return dayjs(this.date).format('MMMM YYYY')
    }
  },
  methods: {
    open(bedDetails) {
      this.dialog = true
      this.bedDetails = bedDetails
    },
    async downloadMonthlyStatement() {
      this.$root.$setLoading(true)
      const tenantId = this.bedDetails.tenant_details.userId
      await this.$store
        .dispatch('payments/downloadMonthlyStatementAction', {
          tenantId,
          date: this.date,
          sortBy: this.sortBy
        })
        .catch((err) => {
          this.$root.$setLoading(false)
          this.$emit('snack', err)
        })
      this.$root.$setLoading(false)
    },
    async sendMonthlyStatement() {
      this.$root
        .$confirm({
          title: 'Send Monthly Statement',
          message:
            'Are you sure you want to send the tenant their monthly statement?'
        })
        .then(async (confirm) => {
          if (confirm) {
            this.$root.$setLoading(true)
            const tenantId = this.bedDetails.tenant_details.userId
            const data = await this.$store.dispatch(
              'payments/sendMonthlyStatementAction',
              {
                tenantId,
                date: this.date,
                sortBy: this.sortBy
              }
            )

            this.$root.$setLoading(false)
            this.$emit('snack', data && data.msg)
          }
        })
        .catch((err) => {
          this.$root.$setLoading(false)
          this.$emit('snack', err)
        })
    }
  }
}
</script>
